const REPORT_EXTRA_FUND_KEYS = [
  "returnVAT",
  "taxesZUS",
  "partner",
  "accountant",
  "carRent",
  "other",
  "refunds",
];

export const parseReportMoneyItems = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (raw == null || raw === "") return [];
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const moneyOrZero = (value) => {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
};

/** Один рядок на статтю. Аліаси (taxesZus, returnVat, otherExpenses) не показуємо повторно. */
export const getReportExtraFundsView = (extraFunds) => {
  const ef = extraFunds && typeof extraFunds === "object" ? extraFunds : {};
  const refundsItems = parseReportMoneyItems(ef.refundsDesc ?? ef.refundsItems ?? ef.refunds_desc);
  const otherExpensesItems = parseReportMoneyItems(ef.other_expenses ?? ef.otherExpenses);

  const valueOf = (key) => {
    if (key === "returnVAT") return ef.returnVAT ?? ef.returnVat ?? 0;
    if (key === "taxesZUS") return ef.taxesZUS ?? ef.taxesZus ?? 0;
    return ef[key] ?? 0;
  };

  const rows = REPORT_EXTRA_FUND_KEYS.filter((key) => {
    const amount = moneyOrZero(valueOf(key));
    if (key === "refunds") return refundsItems.length > 0 || amount !== 0;
    if (key === "other") return otherExpensesItems.length > 0 || amount !== 0;
    return amount !== 0;
  }).map((key) => [key, valueOf(key)]);

  return { rows, refundsItems, otherExpensesItems };
};
